<dx-select-box #selectBox
    [dataSource]="fileTransfers"
    displayExpr="name"
    valueExpr="id"
    [disabled]="isDisabled"
    (selectedItemChange)="onSelectedItemChange($event)"
    [noDataText]="'_pickers.nodata' | translate"
    [placeholder]="'_pickers.placeholder' | translate"
    acceptCustomValue="false"
    searchEnabled="true"
    [showClearButton]="!isRequired">
    <dx-validator>
        <dxi-validation-rule *ngIf="isRequired" type="required" [message]="'_pickers.msgFileTransferRequired' | translate"></dxi-validation-rule>
    </dx-validator>
</dx-select-box>
